import useRootData from "~/hooks/useRootData";

export function useMainNavigationData() {
	return useRootData()?.data.mainNavigation;
}
